<template>
  <div class="order-wrapper">
    <div class="header-text">
      <span class="fill-order">填写订单信息</span>
      <span class="order-success on">订单提交成功</span>
    </div>
    <div class="bottom-bg">
      <div class="top-bg top-bg-all"></div>
    </div>
    <div class="order_success order_success_o order-result">
      <div v-if="is_success">
        <img alt class="order-result-icon" src="@/assets/images/html/success_03.png">
        <div class="order-result-msg">
          <div class="one">
            <span>您的订单已提交成功！客服正在处理中，将尽快联系您！</span>
          </div>
          <div class="customer_service_information order-result-userinfo call_agent">
            <em class="one">销售客服</em>
            <img :src="userinfo.photo_url" alt="销售客服头像" class="server_avatar">
            <em>{{userinfo.customer_service_name ? userinfo.customer_service_name : userinfo.name}}</em>
            <a :href="'tel:' + userinfo.cell" class="tel">
              <img alt="电话号码" class="user-tel" src="~@/assets/images/html/call_03.png">
              <span>{{userinfo.cell}}</span>
            </a>
          </div>
        </div>
      </div>
      <div class="order-result-error" v-else>
        <img alt class="order-result-icon" src="@/assets/images/html/fail.png">
        <div class="order-result-msg">
          <div class="one">
            <span>订单提交失败！{{msg}}&nbsp;请联系旅行销售客服！</span>
          </div>
          <div class="customer_service_information order-result-userinfo call_agent">
            <em class="one">销售客服</em>
            <img :src="userinfo.photo_url" alt="销售客服头像" class="server_avatar">
            <em>{{userinfo.name}}</em>
            <a :href="'tel:' + userinfo.cell" class="tel">
              <img alt="电话号码" class="user-tel" src="~@/assets/images/html/call_03.png">
              <span>{{userinfo.cell}}</span>
            </a>
          </div>
        </div>
        <div class="order-result-error-button">
          <a @click="$router.go(-1)" href="javascript:void(0);">
            <span>返回</span>
          </a>
        </div>
      </div>
    </div>
    <div class="order-result-bottom" v-if="is_success">
      <div class="order-result-route-info">
        <div>
          <div class="one overflow-ellipsis-line1">
            <span>产品名称：</span>
            <em>{{plan_info.route_plan_name}}</em>
          </div>
          <div class="tow">
            <span>订单编号：</span>
            <em>{{order_info.order_info_id}}</em>
          </div>
          <a
            @click="$pushByName('customerOrderDetail',{order_id: order_info_id})"
            href="javascript:void(0);"
          >
            <em>查看订单详情</em>
            <img alt src="~@/assets/images/html/blue_arrow_07.png">
          </a>
        </div>
        <div>
          <div class="one">
            <span>出行日期：</span>
            <em>{{is_visa ? order_info.travel_date : $dateUtil.df(plan_info.depart_time)}}</em>
          </div>
          <div class="tow">
            <span>订单金额：</span>
            <i>{{order_info.total_amount | currency}}</i>
          </div>
          <div>
            <a
              @click="is_expansion=!is_expansion"
              href="javascript:void(0);"
              style="color: black;"
            >明细&nbsp;V</a>
          </div>
        </div>
        <transition>
          <div class="order-amount-info-table" v-show="is_expansion">
            <table>
              <tr>
                <th id="price_categories">价格种类</th>
                <th>单价</th>
                <th>订购</th>
                <th>应收金额</th>
              </tr>
              <tr v-for="(price_item, index) in price_list" v-if="price_list.length > 0">
                <td class="text">{{price_item.name}}</td>
                <td>{{price_item.price}}</td>
                <td>{{price_item.num}}</td>
                <td style="color:#313131;">{{price_item.total}}</td>
              </tr>
            </table>
          </div>
        </transition>
      </div>
      <div class="order-result-hint">
        <span>温馨提示：请尽快完成支付，超时订单可能会被取消。</span>
      </div>
      <div class="order-result-pay" v-if="is_success">
        <div class="order-pay-button">
          <a @click="payWeixin()" href="javascript:void(0);">
            <span>立即支付</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RouteOrderResult',
  componentName: 'RouteOrderResult',
  data () {
    return {
      is_success: false,
      msg: '',
      _user_name: '',
      order_info_id: 0,
      userinfo: {},
      plan_info: {},
      order_info: {},
      is_visa: false,
      is_expansion: false,
      price_list: [], //价格明细
    }
  },
  created () {
    this.init()
    this.getRouteOrderResult()
  },
  mounted () {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.goBack, false)
    }
  },
  destroyed () {
    window.removeEventListener('popstate', this.goBack, false)
  },
  methods: {
    goBack () {
      window.removeEventListener('popstate', this.goBack, false)
      if (this.is_success) {
        this.$router.replace({ name: 'memberInfo' })
      } else {
        this.$router.go(-1)
      }
    },
    init () {
      this.is_success = this.$route.query.is_success == 'true' || this.$route.query.is_success == true
      this.msg = this.$route.query.msg
      this._user_name = this.$route.query._user_name
      this.order_info_id = this.$route.query.order_info_id

      const price_list = this.$sessionStorageUtil.get('price_list')
      if (price_list) {
        this.price_list = price_list
      }
    },
    getRouteOrderResult () { // 从后台接口获取订单列表，
      const url = 'order_info/get_route_order_result'
      const form_info = {
        _user_name: this._user_name,
        order_info_id: this.order_info_id

      }
      var fields = this.$myPost(url, form_info)
      fields.then(res => {
        this.userinfo = res.response.data.userinfo
        this.plan_info = res.response.data.plan_info
        this.order_info = res.response.data.order_info

        if (this.order_info.product_category == 10) {
          this.is_visa = true
          this.order_info.travel_date = JSON.parse(this.order_info.order_note).speciality.travel_date
        }
      })
        .catch(err => {
          console.log('err:' + err)
        })

    },
    payWeixin () {
      //iOS在jsAPI支付时，地址还是刚从公众号时进入时的地址(对单页应用程序)，需要强制刷新页面。否则会出现“当前页面URL未注册”的错误
      this.$util.href('pay/payWeixin?order_id=' + this.order_info_id, this.$router);
    }
  }
}
</script>
<style scoped>
</style>




// WEBPACK FOOTER //
// src/pages/customer/route/routeOrderResult.vue